import React from "react";
import { createOne } from "actions/reader";
import { connect } from "react-redux";
import * as R from "ramda";
import ReaderFormFields from "components/ReaderFormFields";
import { fetchAll } from "actions/user";
import { withRouter } from "react-router-dom";

const mapDispatchToProps = {
  createOne,
  fetchAll
};

const mapStateToProps = state => ({
  isUpdating: state.reader.isUpdating,
  users: state.user.byId,
  isFetching: state.user.isFetching
});

class AdminReaderCreate extends React.Component {
  state = {
    reader: {
      id: ""
    }
  };

  componentWillMount() {
    this.props.fetchAll();
  }

  handleSubmit = event => {
    event.preventDefault();
    const { createOne, history } = this.props;
    const { reader } = this.state;
    createOne(reader).then(data => {
      history.push("/admin/reader/list");
    });
  };

  handleChange = (fields, value) => {
    this.setState(R.assocPath(fields, value));
  };

  render() {
    const { users, isFetching } = this.props;
    const items = Object.keys(users).map(id => users[id]);
    if (!(!isFetching && items)) {
      return null;
    }
    return (
      <form onSubmit={this.handleSubmit}>
        <div className="form-group">
          <ReaderFormFields
            reader={this.state.reader}
            onChange={this.handleChange}
            nodate
            nocustomer
            user={items}
          />
          <button id="submit" name="submit" className="btn btn-primary">
            Legg til leser
          </button>
        </div>
      </form>
    );
  }
}

export default R.compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(AdminReaderCreate);



// WEBPACK FOOTER //
// ./src/components/AdminReaderCreate.js